








































































































































import queryString from 'query-string';
import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import { IDRec, TableOptions, VForm } from '@/interfaces';
import FileUpload from '@/components/FileUpload.vue';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import { readUserProfile } from '@/store/main/getters';
import { Dictionary } from 'vue-router/types/router';

@Component({
  components: {
    FileUpload
  }
})
export default class ReportFileTable extends Mixins(CommonMixin) {
  // Props
  @Prop() public rec!: IDRec;
  @Prop(String) public url!: string;
  @Prop(String) public fileUrl!: string;
  @Prop(String) public tooltip!: string;
  @Prop(String) public parameter!: string;
  @Prop(String) public linkTo!: string;
  @Prop(Boolean) public isEditable!: boolean;
  @Prop(Boolean) public isNew!: boolean;

  public tableTotal: number = 0;
  public fileDeleteTitle = 'dit bestand';
  public filesDeleteTitle = 'deze bestanden';
  public filesLoading = false;
  public files: any[] = [];
  public newFile: any = {
    id: 0
  };
  public selectedFiles: IDRec[] = [];
  public deleteDialogValue = false;
  public uploadDialogValue = false;
  public loading = false;
  public totalFiles = 0;
  public count = 1;
  public formValid = false;

  public fileTableFields = [
    {
      text: 'Bestand',
      value: 'file.name',
      width: '30%'
    },
    {
      text: 'Type',
      value: 'filetype_name',
      width: '10%'
    },
    {
      text: 'Omschrijving',
      value: 'description',
      width: '30%'
    },
    {
      text: 'Datum',
      value: 'file.timestamp',
      width: '15%',
      filter: 'date'
    },
    {
      text: 'Gebruiker',
      value: 'user_name',
      width: '15%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '5%',
      filter: 'prettyBytes'
    }
  ];
  public tableFooterProps = {
    'items-per-page-options': [10],
    'show-current-page': true,
    'show-first-last-page': true
  };
  public tableOptions: TableOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['file.timestamp'],
    sortDesc: [true],
    multiSort: true,
    mustSort: false
  };

  public get fileTableHeaders() {
    const headers: object[] = [];
    for (const field of this.fileTableFields) {
      const header = {
        text: field.text,
        value: field.value,
        width: field.width || ''
      };
      headers.push(header);
    }
    return headers;
  }

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

  public get userDisplayName() {
    const profile = readUserProfile(this.$store);
    return profile ? profile.display_name : '';
  }

  @Mutation('setFilters')
  public setFilters;

  @Mutation('setAdvancedSearchVisible')
  public setAdvancedSearchVisible;

  public generateSlotName(header): string {
    return `item.${header}`;
  }

  // Support nested values
  public getItemValue(item, value) {
    const subelements = value.split('.');
    let itemValue = item;
    for (const subelement of subelements) {
      itemValue = itemValue[subelement];
    }
    return itemValue;
  }

  public openFileOverview(rec) {
    const id = rec[this.linkTo];
    if (id) {
      const queryObj = {
        [this.linkTo]: id,
        advanced: true
      };
      const path = this.url + '?' + queryString.stringify(queryObj);
      const routeData = this.$router.resolve({
        path
      });
      window.open(routeData.href, '_blank');
    }
  }

  public addFile() {
    this.uploadDialogValue = true;
    this.theForm.resetValidation();
  }

  public getSortString() {
    let sort: string = '';
    const sortBy: string[] = this.tableOptions.sortBy;
    const sortDesc: boolean[] = this.tableOptions.sortDesc;
    for (let i = 0; i < sortBy.length; i++) {
      if (!sort) {
        // First sort parameter
        sort = sortBy[i] + (sortDesc[i] ? '|D' : '');
      } else {
        sort += ',' + sortBy[i] + (sortDesc[i] ? '|D' : '');
      }
    }
    return sort;
  }

  public async getFiles(id) {
    const params: Dictionary<number | string> = {
      page: this.tableOptions.page,
      per_page: this.tableOptions.itemsPerPage
    };
    params.sort = this.getSortString();
    params[this.parameter] = String(id);
    const fileResponse: any = await this.api.getRecord(
      undefined,
      this.fileUrl,
      params
    );
    if (fileResponse) {
      this.files = fileResponse.data.data;
      this.tableTotal = fileResponse.data.pagination.total;
      this.filesLoading = false;
    }
  }

  public downloadFile(id) {
    if (!this.isNew) {
      this.api.downloadFile(this.$store, this.fileUrl + id + '/file/url');
    }
  }

  public downloadSelectedFiles() {
    for (const file of this.selectedFiles) {
      this.downloadFile(file.id);
    }
  }

  public deleteItems() {
    this.deleteDialogValue = true;
  }

  public deleteSelectedFiles() {
    for (const file of this.selectedFiles) {
      this.deleteFile(file.id);
    }
    this.selectedFiles = [];
  }

  public async deleteFile(id) {
    if (!this.isNew) {
      this.filesLoading = true;
      await this.api.deleteRecord(null, this.fileUrl + String(id));
      this.getFiles(this.$route.params.id);
    } else {
      this.files.splice(id, 1);
      // Reset id's
      for (let i = 0; i < this.files.length; i++) {
        this.files[i].id = i;
      }
    }
  }

  public async addFiles() {
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      if (!this.isNew) {
        this.commitFiles();
      } else {
        this.saveFiles();
      }
    }
  }

  public async saveFiles() {
    const ref: any = this.$refs.upload;
    const fileTypeId = this.newFile.file_type_id;
    const fileTypeName = await this.getFileTypeName(fileTypeId);
    // Only execute when at least 1 file is selected
    this.totalFiles = ref.files.length;
    if (this.totalFiles > 0) {
      ref.errorMessages = '';
      for (const x of Object.keys(ref.files)) {
        const formData = new FormData();
        const file: Blob = ref.files[x];
        formData.append('file', file);
        const index = this.files.length;
        const fileObject = {
          id: index,
          file: {
            name: ref.files[x].name,
            timestamp: moment().toISOString(),
            size: ref.files[x].size
          },
          description: this.newFile.description,
          user_name: this.userDisplayName,
          filetype_name: fileTypeName,
          file_type_id: fileTypeId,
          form_data: formData
        };
        this.files.push(fileObject);
      }
      ref.files = [];
      this.newFile = {
        id: 0
      };
      this.uploadDialogValue = false;
    }
  }

  public async commitFiles() {
    const ref: any = this.$refs.upload;
    (this.newFile as any)[this.parameter] = this.rec.id;
    // Only execute when at least 1 file is selected
    this.totalFiles = ref.files.length;
    if (this.totalFiles > 0) {
      this.loading = true;
      ref.errorMessages = '';

      for (const x of Object.keys(ref.files)) {
        const recordResponse = await this.api.createRecord(
          undefined,
          this.fileUrl,
          this.newFile
        );
        if (recordResponse) {
          const id = recordResponse.data.id;
          const formData = new FormData();
          const file: Blob = ref.files[x];
          formData.append('file', file);
          const response = await this.api.uploadFile(
            undefined,
            this.fileUrl + id + '/file',
            formData
          );
        }
        this.count += 1;
      }
      this.loading = false;
      this.count = 1;
      ref.files = [];
      this.newFile = {
        id: 0
      };
      this.uploadDialogValue = false;
      this.filesLoading = true;
      this.getFiles(this.$route.params.id);
    }
  }

  public async saveAllFiles(id) {
    // Only execute when at least 1 file is saved
    this.totalFiles = this.files.length;
    if (this.totalFiles > 0) {
      for (const f of this.files) {
        const newFile: any = {
          id: 0,
          file_type_id: f.file_type_id,
          description: f.description
        };
        newFile[this.parameter] = id;
        const recordResponse = await this.api.createRecord(
          undefined,
          this.fileUrl,
          newFile
        );
        if (recordResponse) {
          const fileId = recordResponse.data.id;
          const response = await this.api.uploadFile(
            undefined,
            this.fileUrl + fileId + '/file',
            f.form_data
          );
        }
      }
    }
  }

  public async uploadFiles(id) {
    const ref: any = this.$refs.upload;
    // Only execute when at least 1 file is selected
    if (ref.files.length > 0) {
      ref.errorMessages = '';
      const formData = new FormData();
      for (const x of Object.keys(ref.files)) {
        const file: Blob = ref.files[x];
        formData.append('file', file);
      }
      const response = await this.api.uploadFile(
        undefined,
        this.fileUrl + id + '/file',
        formData
      );
      ref.files = [];
    }
  }

  public async getFileTypeName(id) {
    const response: any = await this.api.getRecord(
      undefined,
      '/filetypes/' + id
    );
    if (response) {
      const fileType = response.data;
      return fileType.description;
    } else {
      return '';
    }
  }

  public mounted() {
    if (!this.isNew) {
      this.filesLoading = true;
      this.getFiles(this.$route.params.id);
    }
  }

  @Watch('tableOptions')
  public onPropertyChanged(value: string, oldValue: string) {
    this.getFiles(this.$route.params.id);
  }
}
